import React, { useState, useEffect } from "react";
import { serverURL } from "../config/urls";
import { useNavigate } from "react-router-dom";
import { useUserProfile } from './user-profile-context';
import { logEvent } from "@firebase/analytics";
import { analytics } from '../config/firebase-logging';
import { useCareerContext } from "./career-context";
export default function Payment() {
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const { userProfile } = useUserProfile();
    const { handleError } = useCareerContext();
    // Listen for redirect back from stripe with useEffect
    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        if (query.get('success')) {
            setMessage('Payment successful! You can now access all premium features.');
            // get updated jwt token
            fetch(serverURL + '/auth/refresh', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    profile: { ...userProfile, isPremium: true }
                })
            })
            .then(response => response.json())
            .then(data => {
                localStorage.setItem('token', data.token);
            })
            .catch(err => {
                handleError("An unknown error occurred");
                if (process.env.REACT_APP_ENVIRONMENT === "production") {
                    logEvent(analytics, 'error', { error_message: "payment_error: " + err.message })
                } else {
                    console.log(err);
                }
            })
        }
        if (query.get('canceled')) {
            setMessage('Payment canceled.');
        }
    }, []);

    function handlePayment() {
        fetch(serverURL + '/create-checkout-session', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(response => response.json())
        .then(data => {
            window.location = data.url;
        })
        .catch(err => {
            console.log(err);
        })
    }


    return (
        <div>
            {
                message ?
                    <div>
                        {
                            (message === 'Payment successful! You can now access all premium features.') ?
                                <div className="container center">
                                    <img src={require("../img/loading_plant.gif")} alt="Loading..." style={{ width: "100px", height: "100px" }} />
                                    <h1>Thank You</h1>
                                    <p>{message}</p>
                                    <button className="primary-btn" onClick={() => navigate('/careers')}>Go To Careers</button>
                                </div> :
                                <div className="container center">
                                    <img src={require("../img/loading_plant.gif")} alt="Loading..." style={{ width: "100px", height: "100px" }} />
                                    <h1>Oops!</h1>
                                    <p>{message}</p>
                                    <button className="primary-btn" onClick={() => navigate('/careers')}>Back to Careers</button>
                                </div>
                        }

                    </div> :
                    <div style={{ background: "antiquewhite", paddingTop: "20px", minHeight: "calc(100vh - 70px" }}>
                        <div className="container center" style={{ width: "500px", maxWidth: "90%" }}>
                            <div>
                                <h1 style={{ margin: "0" }}>This career requires premium.</h1>
                            </div>
                            <p>A one-time payment for all features and careers, including ones that are released in the future.</p>
                            <div className="product-card" style={{ background: "white", width: "300px", maxWidth: "90%", margin: "auto", borderRadius: "15px" }}>
                                <div style={{ textAlign: "left", padding: "20px" }}>
                                    <p style={{ margin: 0, color: "black" }}>Career Sample Premium</p>
                                    <p style={{ margin: 0, color: "gray" }}>$15.00</p>
                                </div>
                                <button style={{ width: "100%", borderRadius: "0  0 15px 15px" }} className="primary-btn" onClick={handlePayment}>Get Premium</button>
                            </div>
                        </div>
                    </div>
            }
        </div>
    )

}